import { createFileRoute } from '@tanstack/react-router';
import { CompanySetupForm } from '../../../features/org/components/CompanySetupForm';
import { useCompanies } from '../../../features/org/network/org.api';
import { PageHeader } from '../../../components/layout/PageHeader';
import { Skeleton } from '../../../components/ui/Skeleton';
import { usePageTitle } from '../../../lib/hooks.js';
import { DataView } from "../../../components/ui/DataView";

export const Route = createFileRoute('/_auth/setup/company')({
  component: CompanySetupPage,
});

function CompanySetupPage() {
  usePageTitle('Company Setup');
  const companiesQuery = useCompanies();
      const { data: companies } = companiesQuery;
  // The spec says this is a "one-time setup gate" but likely doubles as an edit view.
  // We'll take the first company if it exists (V1 typically has one company per group initially).
  const existingCompany = companies && companies.length > 0 ? companies[0] : null;

  return (
    
      <div className="space-y-8">
        
        <DataView query={companiesQuery}>
        {(companies) => (
          <>
            <PageHeader
                  title={existingCompany ? 'Company Settings' : 'Company Setup'}
                  subtitle={existingCompany 
                    ? 'Update your legal and registration details.' 
                    : 'Register your legal entity to begin operations.'}
                /><CompanySetupForm initialData={existingCompany} />
          </>
        )}
        </DataView>
      </div>

    );
}
